import { YearMonthFns } from '../utils/datetime'
import { DateRangePickerDay } from './date-range-picker-day'
import { DateRangePickerMonth } from './date-range-picker-month'
import { DateRangePickerRoot } from './date-range-picker-root'
import { useDateRangePicker, useDateRangePickerResult } from './use-date-range-picker'
import { DateRangePickerPrev } from './date-range-picker-prev'
import { DateRangePickerNext } from './date-range-picker-next'

export const HeadlessDateRangePicker = Object.assign(DateRangePickerRoot, {
  Day: DateRangePickerDay,
  Month: DateRangePickerMonth,
  Prev: DateRangePickerPrev,
  Next: DateRangePickerNext,
  getCalendarDays,
  useDateRangePicker: useDateRangePicker
})

export type { DateRangePickerRootProps as HeadlessDateRangePickerProps } from './date-range-picker-root'

export type useHeadlessDateRangePickerResult = useDateRangePickerResult

function getCalendarDays(month: string): string[] {
  const startingDayOfWeek = YearMonthFns.getStartingDayOfWeek(month)
  const daysInMonth = YearMonthFns.getDaysInMonth(month)
  const daysInPrevMonth = YearMonthFns.getDaysInMonth(YearMonthFns.getPrev(month))

  const days = Array.from({
    length: startingDayOfWeek + daysInMonth + 7 - ((startingDayOfWeek + daysInMonth) % 7 || 7)
  }).map((_, i) => {
    if (i < startingDayOfWeek) {
      const day = daysInPrevMonth - startingDayOfWeek + i + 1
      return `${YearMonthFns.getPrev(month)}-${((day || 0) > 9 ? '' : '0') + day}`
    } else if (i >= startingDayOfWeek + daysInMonth) {
      const day = i + 1 - startingDayOfWeek - daysInMonth
      return `${YearMonthFns.getNext(month)}-${((day || 0) > 9 ? '' : '0') + day}`
    } else {
      const day = i - startingDayOfWeek + 1
      return `${month}-${((day || 0) > 9 ? '' : '0') + day}`
    }
  })

  return days
}
